import Vue from 'vue';
import VueRouter from 'vue-router';
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
import GSignInButton from 'vue-google-signin-button';

import { getApiBaseUrl, isInternal, tokenIsValid } from './utils';
import { ROUTES } from './pages';
import { ARNEO_ECOCONCEPTION_CROWD_TOKEN } from './constants';

Vue.use(VueRouter);
Vue.use(GSignInButton);

Vue.config.productionTip = false;

/**
 * Routing
 */
const router = new VueRouter({
  routes: ROUTES,
});

/**
 * Before each routing
 */
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = await tokenIsValid();

  if (isAuthenticated) {
    Vue.use(
      VueSocketIOExt,
      io(getApiBaseUrl(), {
        autoConnect: false,
        allowUpgrades: true,
        transports: ['websocket', 'polling'],
        timeout: 600000,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.5,
        query: {
          socketId: localStorage.getItem('socketId') || '',
          accessToken:
            localStorage.getItem(ARNEO_ECOCONCEPTION_CROWD_TOKEN) || '',
        },
      }),
    );
  }

  /**
   * Internal user try to access Audit page without being logged-in
   */
  if (to.name === 'Audit' && isInternal() && !isAuthenticated) {
    // Redirect to Login page
    next({ name: 'Login' });
  } else if (to.name === 'Login' && isInternal() && isAuthenticated) {
    /**
     * Internal user try to access Login page but already logged-in
     */
    // Redirect to Audit page
    next({ name: 'Audit' });
  } else {
    // Continue normally
    next();
  }
});

/**
 * Vue instance
 */
new Vue({
  router,
}).$mount('#app');
